import { takeEvery, takeLatest } from "redux-saga/effects";

import {
  filterRoutes,
  geocodeLocation,
  hideLeadFinder,
  hideLeads,
  initializeAddRecords,
  removeSearchHistoryItem,
  saveSearch,
  setDistanceSettings,
  setSearchHistory,
  showHiddenLeads,
  showLeadFinder,
  startLeadFinderSearch,
  submitAddRecords,
  toggleLeadFinder,
} from "../actions";

import { onFilterRoutes, onInitializeAddRecords, onSubmitAddRecords } from "./addRecords";
import { onHideLeads, onShowHiddenLeads } from "./leads";
import { onGeocodeLocation, onStartLeadFinderSearch } from "./search";
import {
  onHideLeadFinder,
  onRemoveSearchHistoryItem,
  onSaveSearch,
  onSaveSearchHistory,
  onSetDistanceSettings,
  onShowLeadFinder,
  onToggleLeadFinder,
} from "./settings";

export function* leadFinderSagas() {
  yield takeLatest(startLeadFinderSearch.request, onStartLeadFinderSearch);
  yield takeLatest(geocodeLocation.request, onGeocodeLocation);
  yield takeLatest(initializeAddRecords.request, onInitializeAddRecords);
  yield takeLatest(submitAddRecords.request, onSubmitAddRecords);
  yield takeLatest(showLeadFinder, onShowLeadFinder);
  yield takeLatest(hideLeadFinder, onHideLeadFinder);
  yield takeLatest(toggleLeadFinder, onToggleLeadFinder);
  yield takeLatest(saveSearch, onSaveSearch);
  yield takeEvery(removeSearchHistoryItem, onRemoveSearchHistoryItem);
  yield takeLatest(setSearchHistory, onSaveSearchHistory);
  yield takeLatest(setDistanceSettings, onSetDistanceSettings);
  yield takeLatest(hideLeads.request, onHideLeads);
  yield takeLatest(showHiddenLeads.request, onShowHiddenLeads);
  yield takeLatest(filterRoutes.request, onFilterRoutes);
}
